import { init } from '@sentry/vue'

export default defineNuxtPlugin(nuxtApp => {
	const config = useRuntimeConfig()
	init({
		app: nuxtApp.vueApp,
		dsn: '',
		environment: config.public.environment,
	})
})
